import { reduxForm, formValueSelector } from 'redux-form';
import { connect } from 'react-redux';

import PurchaseOrderForm from '../../components/Purchase/purchaseOrderForm';
import { fetchVendors, fetchActiveVendors, fetchVendorDetail, resetCurrentVendor } from '../../actions/vendors_actions';
import { fetchProductsByVendor, fetchProductInfo, fetchSimplifiedProducts } from '../../actions/products_actions';
import { fetchPaymentTerms } from '../../actions/paymentTerms_actions';
import { fetchWarehouses } from '../../actions/warehouses_actions';
import { fetchTaxRates } from '../../actions/sales_actions';
import { selectPurchaseOrder, resetCurrentPurchaseOrder, fetchPurchaseOrderDetail, editPurchaseOrder, createPurchaseOrder, createDropship, setDefaultSearchType, setDefaultOfForm, initializeForm,
  setPriceValues, setDefaults, setValue, clearRemarks, setDefaultVendorAddress, setAllProducts, resetAllProducts, setInitialForm, setDefaultIsDropship, setDefaultConvertItemPrice, initializedPurchaseOrderForm } from '../../actions/purchaseOrders_actions';
import { fetchPurchaseQuoteDetail, editPurchaseQuote, createPurchaseQuote, purchaseQuotePlace, resetCurrentPurchaseQuote, selectPurchaseQuote } from '../../actions/purchaseQuotes_actions';
import { convertTemplateToQuote } from '../../actions/purchaseTemplates_actions';
import { fetchPurchaseTemplateDetail, editPurchaseTemplate, createPurchaseTemplate, resetCurrentPurchaseTemplate, selectPurchaseTemplate } from '../../actions/purchaseTemplates_actions';
import { printPurchaseOrder, printPickup } from '../../actions/print_actions';

  const isNumeric = function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
  };

  const validate = (values, props) => {
    const errors = {}

    if (values.AllProd_Quantity && !isNumeric(values.AllProd_Quantity)) {
        errors.AllProd_Quantity = 'Accept number only!'
    }
    if (values.AllProd_Quantity && (values.AllProd_Quantity < 0)) {
        errors.AllProd_Quantity = 'Positive number only!'
    }
    if (values.AllProd_FOBUnitPrice && !isNumeric(values.AllProd_FOBUnitPrice)) {
        errors.AllProd_FOBUnitPrice = 'Accept number only!'
    }
    if (values.AllProd_FOBUnitPrice && (values.AllProd_FOBUnitPrice < 0)) {
        errors.AllProd_FOBUnitPrice = 'Positive number only!'
    }
    if (values.AllProd_EstSalePrice && !isNumeric(values.AllProd_EstSalePrice)) {
        errors.AllProd_EstSalePrice = 'Accept number only!'
    }
    if (values.AllProd_EstSalePrice && (values.AllProd_EstSalePrice < 0)) {
        errors.AllProd_EstSalePrice = 'Positive number only!'
    }
    if (values.Quantity && !isNumeric(values.Quantity)) {
        errors.Quantity = 'Accept number only!'
    }
    if (values.FOBUnitPrice && !isNumeric(values.FOBUnitPrice)) {
        errors.FOBUnitPrice = 'Accept number only!'
    }
    if (values.FOBUnitPrice && (values.FOBUnitPrice < 0)) {
        errors.FOBUnitPrice = 'Positive number only!'
    }
    if (values.EstSalePrice && !isNumeric(values.EstSalePrice)) {
        errors.EstSalePrice = 'Accept number only!'
    }
    if (values.ShippingCost && !isNumeric(values.ShippingCost)) {
        errors.ShippingCost = 'Accept number only!'
    }
    if (values.ShippingCost && (values.ShippingCost < 0)) {
        errors.ShippingCost = 'Positive number only!'
    }
    if (values.HandlingCost && !isNumeric(values.HandlingCost)) {
        errors.HandlingCost = 'Accept number only!'
    }
    if (values.HandlingCost && (values.HandlingCost < 0)) {
        errors.HandlingCost = 'Positive number only!'
    }
    if (values.MiscCost && !isNumeric(values.MiscCost)) {
        errors.MiscCost = 'Accept number only!'
    }
    if (values.MiscCost && (values.MiscCost < 0)) {
        errors.MiscCost = 'Positive number only!'
    }
    if (values.Adjustments && !isNumeric(values.Adjustments)) {
        errors.Adjustments = 'Accept number only!';
    }
    if (values.Discount && !isNumeric(values.Discount)) {
        errors.Discount = 'Accept number only!'
    }
    if (values.Discount && (values.Discount < 0)) {
        errors.Discount = 'Positive number only!'
    }

    if (!values.ShippingMethod) {
        errors.ShippingMethod = 'Required'
    }

    if (!values.Vendor_id) {
        errors.Vendor_id = 'Required'
    }

    // if (values.TaxRate && !isNumeric(values.TaxRate)) {
    //     errors.TaxRate = 'Accept number only!'
    // }
    // if (values.TaxRate && (values.TaxRate < 0)) {
    //     errors.TaxRate = 'Positive number only!'
    // }


    return errors;
}
let purchaseOrderForm = reduxForm({
    form: 'purchaseOrderForm',
    validate,
    enableReinitialize: true,
    touchOnChange: true,
    touchOnBlur: false,
})(PurchaseOrderForm);

// let today = new Date();
// let initialValues = {
//   OrderDate: today
// }
//
// purchaseOrderForm = connect(
//     state => ({
//       initialValues: initialValues
//     })
// )(purchaseOrderForm)

const selector = formValueSelector('purchaseOrderForm')

function mapStateToProps(state) {
    const productInformation = selector(state, 'ProductInformation');

    const productsValue = selector(state, 'Purchase_Order_Line');
    const vendorsValue = selector(state, 'Vendor_id');
    const vendorContactValue = selector(state, 'VendorContact');
    const priceTypeValue = selector(state, 'ConvertItemPrice');
    const miscCostValue = selector(state, 'MiscCost');
    const handlingCostValue = selector(state, 'HandlingCost');
    const shippingCostValue = selector(state, 'ShippingCost');
    const adjustmentValue = selector(state, 'PriceAdjustment');
    const allProducts = selector(state, 'AllProducts');
    const allProdQuantity = selector(state, 'AllProd_Quantity');
    const weight = selector(state, 'Weight');
    const allProdFOBUnitPrice = selector(state, 'AllProd_FOBUnitPrice');
    const allProdEstSalePrice = selector(state, 'AllProd_EstSalePrice');
    const FOBUnitPrice = selector(state, 'FOBUnitPrice');
    const remark = selector(state, 'Remark');
    const allProdRemark = selector(state, 'AllProd_Remark');
    const searchType = selector(state, 'searchType');
    const isDropship = selector(state, 'IsDropship');
    const shippingMethod = selector(state, 'ShippingMethod');
    const orderDate = selector(state, 'OrderDate');

    const taxRate = selector(state, 'TaxRate');

    return {
        productInformation: productInformation,

        productsValue: productsValue,
        vendorsValue: vendorsValue,
        vendorContactValue: vendorContactValue,
        priceTypeValue: priceTypeValue,
        miscCostValue: miscCostValue,
        shippingCostValue,
        handlingCostValue,
        adjustmentValue,
        allProducts,
        allProdQuantity,
        weight,
        allProdFOBUnitPrice,
        allProdEstSalePrice,
        FOBUnitPrice,
        remark,
        allProdRemark,
        searchType,
        isDropship,
        shippingMethod,
        orderDate,
        taxRate,

        currentPurchaseOrderDetail: state.purchaseOrders.currentPurchaseOrderDetail,
        currentPurchaseOrder: state.purchaseOrders.currentPurchaseOrder,
        currentPurchaseQuoteDetail: state.purchaseQuotes.currentPurchaseQuoteDetail,
        currentPurchaseQuote: state.purchaseQuotes.currentPurchaseQuote,
        currentPurchaseTemplate: state.purchaseTemplates.currentPurchaseTemplate,
        currentPurchaseTemplateDetail: state.purchaseTemplates.currentPurchaseTemplateDetail,
        detailIsLoading: state.purchaseOrders.detailIsLoading||state.purchaseQuotes.detailIsLoading||state.purchaseTemplates.detailIsLoading,
        detailError: state.purchaseOrders.detailError||state.purchaseQuotes.detailError||state.purchaseTemplates.detailError,
        initialValues: state.purchaseOrders.currentPurchaseOrderDetail||state.purchaseQuotes.currentPurchaseQuoteDetail||state.purchaseTemplates.currentPurchaseTemplateDetail,

        isEditing: state.purchaseOrders.purchaseOrderIsEditing||state.purchaseQuotes.purchaseQuoteIsEditing||state.purchaseTemplates.purchaseTemplateIsEditing,
        editError: state.purchaseOrders.purchaseOrderEditError||state.purchaseQuotes.purchaseQuoteEditError||state.purchaseTemplates.purchaseTemplateEditError,
        isCreating: state.purchaseOrders.purchaseOrderIsCreating||state.purchaseQuotes.purchaseQuoteIsCreating||state.purchaseTemplates.purchaseTemplateIsCreating,
        createError: state.purchaseOrders.purchaseOrderCreateError||state.purchaseQuotes.purchaseQuoteCreateError||state.purchaseTemplates.purchaseTemplateCreateError,

        purchaseOrderCreated: state.purchaseOrders.purchaseOrderCreated,
        purchaseOrderEdited: state.purchaseOrders.purchaseOrderEdited,

        isPlacing: state.purchaseQuotes.purchaseQuoteIsPlacing,
        placeError: state.purchaseQuotes.purchaseQuotePlaceError,
        purchaseOrderPlaced : state.purchaseQuotes.purchaseQuotePlaced,

        purchaseQuoteCreated: state.purchaseQuotes.purchaseQuoteCreated,
        purchaseQuoteEdited: state.purchaseQuotes.purchaseQuoteEdited,

        purchaseTemplateCreated:state.purchaseTemplates.purchaseTemplateCreated,
        purchaseTemplateEdited : state.purchaseTemplates.purchaseTemplateEdited,

        products: state.products.allByVendor,
        productIsLoading: state.products.isLoading,
        productError: state.products.error,
        productInfo: state.products.productInfo,
        productInfoIsLoading: state.products.productInfoIsLoading,
        productInfoError: state.products.productInfoError,
        vendors: state.vendors.all,
        vendorIsLoading: state.vendors.isLoading,
        vendorError: state.vendors.error,
        currentVendorDetail: state.vendors.currentVendorDetail,
        vendorDetailIsLoading: state.vendors.detailIsLoading,
        vendorDetailError: state.vendors.detailError,
        paymentTerms: state.paymentTerms.all,
        paymentTermsIsLoading: state.paymentTerms.isLoading,
        paymentTermsError: state.paymentTerms.error,
        warehouses: state.warehouses.all,
        warehouseIsLoading: state.warehouses.isLoading,
        warehouseError: state.warehouses.error,
        userPermissions: state.auth.userPermissions,

        simplifiedProducts: state.products.simplifiedProducts,
        simplifiedProductsIsLoading: state.products.simplifiedProductsIsLoading,
        simplifiedProductsError: state.products.simplifiedProductsError,

        taxRates: state.salesOrders.taxRates,
        taxRatesIsLoading: state.salesOrders.taxRatesIsLoading,
        taxRatesError: state.salesOrders.taxRatesError,

        purchaseOrderProduct: state.purchaseOrders.purchaseOrderProduct,
        purchaseOrderProductIsLoading: state.purchaseOrders.purchaseOrderProductIsLoading,
        purchaseOrderProductError: state.purchaseOrders.purchaseOrderProductError,

        requestingPurchaseOrderPdf: state.print.requestingPurchaseOrderPdf,
        purchaseOrderPdf: state.print.purchaseOrderPdf,
    }
}

export default connect(mapStateToProps, {
    convertTemplateToQuote,
    createDropship,
    createPurchaseOrder,
    createPurchaseQuote,
    createPurchaseTemplate,
    editPurchaseOrder,
    editPurchaseQuote,
    editPurchaseTemplate,
    fetchActiveVendors,
    fetchPaymentTerms,
    fetchProductInfo,
    fetchProductsByVendor,
    fetchPurchaseOrderDetail,
    fetchPurchaseQuoteDetail,
    fetchPurchaseTemplateDetail,
    fetchSimplifiedProducts,
    fetchVendorDetail,
    fetchVendors,
    fetchWarehouses, fetchTaxRates,
    initializedPurchaseOrderForm,
    initializeForm,
    printPickup,
    printPurchaseOrder,
    purchaseQuotePlace,
    resetAllProducts,
    resetCurrentPurchaseOrder,
    resetCurrentPurchaseQuote,
    resetCurrentPurchaseTemplate,
    resetCurrentVendor,
    selectPurchaseOrder,
    selectPurchaseQuote,
    selectPurchaseTemplate,
    setAllProducts,
    setDefaultConvertItemPrice,
    setDefaultIsDropship,
    setDefaultOfForm,
    setDefaults,
    setDefaultSearchType,
    setDefaultVendorAddress,
    setInitialForm,
    setPriceValues,
    setValue, clearRemarks,
})(purchaseOrderForm)



// WEBPACK FOOTER //
// ./master/jsx/containers/Purchase/purchaseOrderForm.jsx